export class Errors {
    /**
     * Create a new Errors instance.
     */
    constructor() {
        this.errors = {};
    }


    /**
     * Determine if an errors exists for the given field.
     *
     * @param {string} field
     */
    has(field) {
        return this.errors.hasOwnProperty(field);
    }


    /**
     * Determine if we have any errors.
     */
    any() {
        return Object.keys(this.errors).length > 0;
    }


    /**
     * Retrieve the error message for a field.
     *
     * @param {string} field
     */
    get(field) {
        if (this.errors[field]) {
            if (_.isArray(this.errors[field])) {
                return this.errors[field][0];
            }

            return this.errors[field];
        }
    }


    /**
     * Record the new errors.
     *
     * @param {object} errors
     */
    record(errors) {
        this.errors = errors;
    }


    /**
     * Clear one or all error fields.
     *
     * @param {string|null} field
     */
    clear(field) {
        if (field) {
            delete this.errors[field];

            return;
        }

        this.errors = {};
    }

    startsWith(pattern) {
        let customErrors = []

        for (let prop in this.errors) {
            if (_.startsWith(prop, pattern)) {
                let segment = prop.split('.')
                customErrors.push({
                    key: _.last(segment),
                    error: this.errors[prop]
                })
            }
        }

        return customErrors
    }

    list() {
        let list = []

        for (let prop in this.errors) {
            list.push(this.get(prop))
        }

        return list
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/helpers/Form/Errors.js